import React from "react";
import ReactTooltip from "react-tooltip";
import {
  usCurrency,
  noDecimals,
  usdCurrency,
} from "../../../../_shared/helpers/formatting";

export default function HoverModalHeader(props) {
  //Signal Strength Bars Display
  const displayBar = () => {
    let signalStrength = 0;
    if (
      props.cell.row.original.algo.data.CALC_POSITION_LONGBOW_SIGNAL_STRENGTH
    ) {
      signalStrength = Math.round(
        props.cell.row.original.algo.data
          .CALC_POSITION_LONGBOW_SIGNAL_STRENGTH * 10,
      );
    }
    const signalColor = (index) => {
      let primaryColor = "#ffffff";
      let halfColor = "linear-gradient(#3E3E3E 50%, #ffffff 50%)";
      let neutralColor = "#3E3E3E";

      // If Signal Strength returns 'Buy' make bars green.
      if (
        props.cell.row.original.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] ===
        "Buy"
      ) {
        primaryColor = "#75CE41";
        halfColor = "linear-gradient(#3E3E3E 50%, #75CE41 50%)";
        neutralColor = "#3E3E3E";
      }
      // If Signal Strength returns 'Sell' make bars red.
      if (
        props.cell.row.original.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] ===
        "Sell"
      ) {
        primaryColor = "#D33541";
        halfColor = "linear-gradient(#57262B 50%, #D33541 50%)";
        neutralColor = "#57262B";
      }
      const style = [
        [neutralColor, neutralColor, neutralColor, neutralColor, neutralColor],
        [halfColor, neutralColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, neutralColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, halfColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, halfColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, halfColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, primaryColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, primaryColor, halfColor],
        [primaryColor, primaryColor, primaryColor, primaryColor, primaryColor],
      ][signalStrength];
      return style[index];
    };
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          justifyContent: "space-around",
          width: 40,
        }}
      >
        <div
          style={{
            height: 10,
            width: 5,
            backgroundImage: signalColor(0).startsWith("l")
              ? signalColor(0)
              : "unset",
            backgroundColor: signalColor(0),
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 15,
            width: 5,
            backgroundImage: signalColor(1).startsWith("l")
              ? signalColor(1)
              : "unset",
            backgroundColor: signalColor(1),
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 20,
            width: 5,
            backgroundImage: signalColor(2).startsWith("l")
              ? signalColor(2)
              : "unset",
            backgroundColor: signalColor(2),
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 25,
            width: 5,
            backgroundImage: signalColor(3).startsWith("l")
              ? signalColor(3)
              : "unset",
            backgroundColor: signalColor(3),
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 30,
            width: 5,
            backgroundImage: signalColor(4).startsWith("l")
              ? signalColor(4)
              : "unset",
            backgroundColor: signalColor(4),
            borderRadius: 20,
          }}
        ></div>
      </div>
    );
  };
  return (
    <div className="hover-modal-header">
      <div className="header-stock">
        <div>
          {props.cell.row.original.ticker}
          <span style={{ marginLeft: 15 }}>{props.cell.row.original.name}</span>
          {props.beforeSplit > 0 || props.afterSplit > 0 ? (
            <span style={{ cursor: "pointer" }}>
              <span
                style={{
                  border: ".5px solid #75ce41",
                  borderRadius: "45%",
                  padding: "1px 3.5px",
                  fontSize: "6px",
                  backgroundColor: "#222222",
                  color: "#75ce41",
                  marginLeft: 10,
                  position: "relative",
                  bottom: 3,
                }}
              >
                <i class="fa fa-dollar-sign"></i>
              </span>
              <span
                data-tip={`${props.cell.row.cells[0].value} 
                ${props.beforeSplit > 0 ? "will" : ""} split on 
                ${props.ratio} on 
                ${new Intl.DateTimeFormat("en-US", {
                  timeZone: "UTC",
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                }).format(new Date(props ? props.split : null))}.`}
                style={{
                  border: ".5px solid #75ce41",
                  borderRadius: "45%",
                  padding: "1px 3.5px",
                  fontSize: "6px",
                  backgroundColor: "#222222",
                  color: "#75ce41",
                  position: "relative",
                  top: 1,
                  right: 5,
                }}
              >
                <i class="fa fa-dollar-sign"></i>
              </span>
            </span>
          ) : null}
        </div>
        <i
          onClick={() => props.clickModal()}
          className="fas fa-times close-icon"
        ></i>
      </div>
      {/* Last/Closing Price Section */}
      <div className="header-info">
        <div className="price-section">
          <div className="price" style={{ padding: "0px 0px 2px 20px" }}>
            {props.planInterval === "intraday" || props.planInterval === "daily"
              ? `Last\nPrice`
              : `Closing\nPrice`}
          </div>
          <span
            data-multiline={true}
            data-tip={
              props.planInterval === "intraday" ||
              props.planInterval === "daily"
                ? `This is the last price checked at <br /> (${props.updatedDate}).`
                : `This is the closing price checked at <br /> (${props.closingDate}).`
            }
            className="info-icon"
            style={{
              fontWeight: 100,
              position: "absolute",
              top: window.matchMedia("(max-width: 480px)").matches
                ? 62
                : "54px",
              left: window.matchMedia("(max-width: 480px)").matches
                ? 105
                : props.planInterval === "intraday" ||
                  props.planInterval === "daily"
                ? "78px"
                : "100px",
              color: "white",
            }}
          >
            i
          </span>
          {(props.cell.row.original.current_trr_1d ||
            props.cell.row.original.current_trr_1d === 0) && (
            <div className="price-content" style={{ paddingTop: 0 }}>
              <div>
                <div className="closing">Last</div>
                <div
                  className="price-number"
                  style={{
                    color:
                      props.cell.row.original.current_trr_1d[0] === "-"
                        ? "#d33541"
                        : "#75ce41",
                  }}
                >
                  <i
                    className={
                      props.cell.row.original.current_trr_1d[0] === "-"
                        ? "fas fa-sort-down price-icon-down"
                        : "fas fa-sort-up price-icon"
                    }
                    style={
                      props.cell.row.original.current_trr_1d[0] === "-"
                        ? {
                            position: "relative",
                            left:
                              props.cell.row.original.current_trr_1d.length *
                              -1,
                            top: -2,
                          }
                        : props.cell.row.original.px_last >= 10
                        ? {
                            position: "relative",
                            left: -3,
                            top: 4.5,
                          }
                        : {
                            left: props.cell.row.original.current_trr_1d.length,
                            top: 8,
                          }
                    }
                  />
                  {/* if price is >= $100,000, remove decimal to preserve space */}
                  {props.cell.row.original.px_last ||
                  props.cell.row.original.px_last > 0
                    ? props.cell.row.original.px_last >= 10
                      ? props.cell.row.original.px_last.substring(
                          0,
                          props.cell.row.original.px_last - 3,
                        )
                      : props.cell.row.original.px_last
                    : "- - -"}
                </div>
              </div>
              <div>
                {/* Last/Closing Price Change */}
                <div className="closing">$ Chg</div>
                <div
                  className="price-number"
                  style={{
                    color:
                      parseFloat(
                        props.cell.row.original.px_last
                          .substring(1)
                          .replace(/,/g, ""),
                      ) -
                        parseFloat(
                          props.cell.row.original.px_close_1d
                            .substring(
                              1,
                              props.cell.row.original.px_close_1d.length - 1,
                            )
                            .replace(/,/g, ""),
                        ) <
                      0
                        ? "#d33541"
                        : "#75ce41",
                  }}
                >
                  {/* if price is >= $100,000, remove decimal to preserve space */}
                  {props.cell.row.original.px_close_1d
                    ? props.cell.row.original.px_close_1d.length >= 11
                      ? usdCurrency(
                          Math.abs(
                            parseFloat(
                              props.cell.row.original.px_last
                                .substring(1)
                                .replace(/,/g, ""),
                            ) -
                              parseFloat(
                                props.cell.row.original.px_close_1d
                                  .substring(1)
                                  .replace(/,/g, ""),
                              ),
                          ).slice(0, -3),
                        )
                      : usdCurrency(
                          Math.abs(
                            parseFloat(
                              props.cell.row.original.px_last
                                .substring(1)
                                .replace(/,/g, ""),
                            ) -
                              parseFloat(
                                props.cell.row.original.px_close_1d
                                  .substring(1)
                                  .replace(/,/g, ""),
                              ),
                          ),
                        )
                    : "- - -"}
                </div>
              </div>
              <div>
                {/* Last/Closing Percentage Change */}
                <div className="closing">% Chg</div>
                <div
                  className="price-number"
                  style={{
                    color:
                      props.cell.row.original.current_trr_1d[0] === "-"
                        ? "#d33541"
                        : "#75ce41",
                  }}
                >
                  {props.cell.row.original.current_trr_1d
                    ? parseFloat(
                        props.cell.row.original.current_trr_1d.slice(0, -1),
                      ).toFixed(2)
                    : "- - -"}
                  %
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Core Signal Section */}
        <div className="signal-section">
          <div className="title" style={{ paddingBottom: 4 }}>
            Core Signal
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "50% 50%",
              alignItems: "flex-end",
            }}
          >
            <div className="pill-container">
              {/* Core Signal Pill */}
              <div
                className={`indicator-pill ${
                  props.cell.row.original.algo.data[
                    "CALC_POSITION_LONGBOW_SIGNAL"
                  ] === "Buy"
                    ? "green"
                    : props.cell.row.original.algo.data[
                        "CALC_POSITION_LONGBOW_SIGNAL"
                      ] === "Sell"
                    ? "red"
                    : props.cell.row.original.algo.data[
                        "CALC_POSITION_LONGBOW_SIGNAL"
                      ] === "No Action" ||
                      props.cell.row.original.algo.data[
                        "CALC_POSITION_LONGBOW_SIGNAL"
                      ] === "Hold"
                    ? "grey"
                    : "empty-value"
                }-background`}
              >
                {props.cell.row.original.algo.data[
                  "CALC_POSITION_LONGBOW_SIGNAL"
                ]
                  ? props.cell.row.original.algo.data[
                      "CALC_POSITION_LONGBOW_SIGNAL"
                    ] === "Buy"
                    ? "Long"
                    : props.cell.row.original.algo.data[
                        "CALC_POSITION_LONGBOW_SIGNAL"
                      ] === "Sell"
                    ? "Short"
                    : "Neutral"
                  : "- - -"}
              </div>
            </div>
            {/* Core Signal Strength Bars */}
            <div>{displayBar()}</div>
          </div>
        </div>
        {/* Trading Range Section */}
        <div className="header-section trading-range-section hover">
          <div className="trading-range-title">
            <div style={{ paddingRight: 5 }}>Trading Range</div>
          </div>
          <div className="floating-text">% from Trading Range</div>
          <div className="trading-range-info">
            <div className="range-info">
              <div className="range-title">Low</div>
              {/* Low Trading Range Price */}
              <div
                className={`range-number ${
                  props.cell.row.original.algo.data["CALC_TRADE_RANGE_LOW"]
                    ? "green"
                    : "empty-value"
                }`}
              >
                {props.cell.row.original.algo.data["CALC_TRADE_RANGE_LOW"] ||
                props.cell.row.original.algo.data["CALC_TRADE_RANGE_LOW"] > 0
                  ? props.cell.row.original.algo.data["CALC_TRADE_RANGE_LOW"] >=
                    10000
                    ? "$" +
                      noDecimals(
                        props.cell.row.original.algo.data[
                          "CALC_TRADE_RANGE_LOW"
                        ],
                      )
                    : usCurrency(
                        props.cell.row.original.algo.data[
                          "CALC_TRADE_RANGE_LOW"
                        ],
                        props.cell.row.original,
                      )
                  : "- - -"}
              </div>
            </div>
            <div className="range-info">
              <div className="range-title">High</div>
              {/* High Trading Range Price */}
              <div
                className={`range-number ${
                  props.cell.row.original.algo.data["CALC_TRADE_RANGE_HIGH"]
                    ? "red"
                    : "empty-value"
                }`}
              >
                {props.cell.row.original.algo.data["CALC_TRADE_RANGE_HIGH"] ||
                props.cell.row.original.algo.data["CALC_TRADE_RANGE_HIGH"] > 0
                  ? props.cell.row.original.algo.data[
                      "CALC_TRADE_RANGE_HIGH"
                    ] >= 10000
                    ? "$" +
                      noDecimals(
                        props.cell.row.original.algo.data[
                          "CALC_TRADE_RANGE_HIGH"
                        ],
                      )
                    : usCurrency(
                        props.cell.row.original.algo.data[
                          "CALC_TRADE_RANGE_HIGH"
                        ],
                        props.cell.row.original,
                      )
                  : "- - -"}
              </div>
            </div>
            <div className="pill-container">
              {/* Trading Range Pill Signal */}
              <div
                className={`indicator-pill ${
                  props.cell.row.original.algo.data[
                    "CALC_TRADING_RANGE_SIGNAL"
                  ] === "Buy"
                    ? "green"
                    : props.cell.row.original.algo.data[
                        "CALC_TRADING_RANGE_SIGNAL"
                      ] === "Sell"
                    ? "red"
                    : props.cell.row.original.algo.data[
                        "CALC_TRADING_RANGE_SIGNAL"
                      ] === "Hold"
                    ? "grey"
                    : "empty-value"
                }-background`}
                style={{ marginTop: 8, marginLeft: 7 }}
              >
                {props.cell.row.original.algo.data["CALC_TRADING_RANGE_SIGNAL"]
                  ? props.cell.row.original.algo.data[
                      "CALC_TRADING_RANGE_SIGNAL"
                    ] === "Buy"
                    ? "Oversold"
                    : props.cell.row.original.algo.data[
                        "CALC_TRADING_RANGE_SIGNAL"
                      ] === "Sell"
                    ? "Overbought"
                    : "Neutral"
                  : "- - -"}
              </div>
            </div>
            <div className="range-info">
              <div className="range-title">Low</div>
              {/* Low Trading Range Percentage */}
              <div
                className={`range-number ${
                  props.cell.row.original.algo.data[
                    "CALC_TRADE_RANGE_PERCENT_LOW"
                  ]
                    ? "red"
                    : "empty-value"
                }`}
              >
                {props.cell.row.original.algo.data[
                  "CALC_TRADE_RANGE_PERCENT_LOW"
                ]
                  ? props.cell.row.original.algo.data[
                      "CALC_TRADE_RANGE_PERCENT_LOW"
                    ]
                  : "- - -"}
              </div>
            </div>
            <div className="range-info">
              <div className="range-title">High</div>
              {/* High Trading Range Percentage */}
              <div
                className={`range-number ${
                  props.cell.row.original.algo.data[
                    "CALC_TRADE_RANGE_PERCENT_HIGH"
                  ]
                    ? "green"
                    : "empty-value"
                }`}
              >
                {props.cell.row.original.algo.data[
                  "CALC_TRADE_RANGE_PERCENT_HIGH"
                ]
                  ? props.cell.row.original.algo.data[
                      "CALC_TRADE_RANGE_PERCENT_HIGH"
                    ]
                  : "- - -"}
              </div>
            </div>
          </div>
        </div>
        {/* Signal Odds Section */}
        <div
          className="header-section trade-odds"
          style={{ display: "inline-block" }}
        >
          <div className="odds">
            <div style={{ position: "relative", top: -4 }}>
              <div className="odds-text">Signal</div>
              <div className="odds-text">Odds</div>
            </div>
            <div
              className={`odds-number ${
                props.cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS &&
                props.cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS !== null
                  ? props.cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS > 1
                    ? "green"
                    : props.cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS <
                      1
                    ? "red"
                    : "empty-value"
                  : "empty-value"
              }`}
            >
              {props.cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS
                ? props.cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS.toFixed(
                    1,
                  )
                : "- - -"}
            </div>
          </div>
        </div>
        {/* Beta Section */}
        <div className="header-section beta">
          <div className="beta-text">Beta</div>
          <div className="beta-sub-text">TTM</div>
          <div
            className={`beta-number ${
              props.cell.row.original.eqy_beta ? "grey" : "empty-value"
            }`}
          >
            {props.cell.row.original.eqy_beta
              ? props.cell.row.original.eqy_beta
              : "- - -"}
          </div>
        </div>
      </div>
      <ReactTooltip place="right" />
    </div>
  );
}
